const gccsLiveFeedItemDetails = {
  controller: 'LiveFeedItemDetailsController',
  template: require('./template.pug'),
  bindings: {
    dShiftIssue: '<',
    updateShiftIssueDetails: '&'
  }
};

angular.module('public.security-manager.schedule-manager.timeline')
  .component('gccsLiveFeedItemDetails', gccsLiveFeedItemDetails);
